import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { isMobile } from 'react-device-detect';

import Grid from '@mui/material/Grid';
import emailJS from 'emailjs-com';

import './ContactUs.scss';

import Footer from '../../Components/Contacts/Contacts';

const ContactUs = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [btnSendId, setBtnSendId] = useState('');

    useEffect(() => {
        if (name === '' || email === '' || message === '') {
            setBtnSendId('');
        } else {
            setBtnSendId('btnSendActive');
        }
    }, [name, email, message]);

    const sendEmail = (e) => {
        e.preventDefault();
        setBtnSendId('');

        emailJS
            .sendForm(
                'gmailService',
                'template_rjbetfo',
                e.target,
                'qxG8BN4BBGtSYpX3g'
            )
            .then(
                (result) => {
                    if (result.text === 'OK') {
                        e.target.reset();
                        toast.success('Your email has been sent');
                    }
                },
                (error) => {
                    setBtnSendId('btnSendActive');
                    toast.error('Error sending email');
                }
            );
    };

    return (
        <>
            <ToastContainer
                position="bottom-left"
                hideProgressBar={true}
                pauseOnHover={false}
            />
            <div className="contactUsCon">
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>SoftMachine - Contact Us</title>
                    <meta
                        name="description"
                        content="How to develop my business?"
                    />
                    <link
                        rel="canonical"
                        href="http://www.softmachine.co/clients"
                    />
                </Helmet>
                <Grid container>
                    <Grid item xs={12} sm={6}>
                        <form
                            className="contactUsLeft"
                            onSubmit={(e) => sendEmail(e)}
                        >
                            {isMobile && (
                                <div className="contactUsUpperText">
                                    <p>
                                        GIVE US A CALL IF YOU'RE READY TO TAKE
                                        YOUR COMPANY TO THE NEXT LEVEL!
                                    </p>
                                </div>
                            )}
                            <p className="contactUsLeftHeader">CONTACT:</p>
                            <input
                                type="text"
                                placeholder="Your name*"
                                name="from_name"
                                onChange={(e) => setName(e.target.value)}
                            />
                            <input
                                type="email"
                                placeholder="Email*"
                                name="from_email"
                                onChange={(e) => setEmail(e.target.value)}
                            />
                            <textarea
                                placeholder="Message*"
                                name="message"
                                onChange={(e) => setMessage(e.target.value)}
                            />
                            <div className="btnSendCon">
                                <input
                                    id={btnSendId}
                                    className="btnSend"
                                    type="submit"
                                    value="Send"
                                />
                            </div>
                        </form>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <div className="contactUsRight">
                            <div className="upperText">
                                <p>
                                    GIVE US A CALL IF YOU'RE READY TO TAKE YOUR
                                    COMPANY TO THE NEXT LEVEL!
                                </p>
                            </div>
                            <div className="lowerText">
                                <p>
                                    1658, Jounieh, Lebanon 4th floor, Bitar
                                    Bldg, Sahel Alma Jounieh, Lebanon <br />
                                    <b>E:</b> INFO@SOFTMACHINE.CO <br />
                                    <b>P:</b> +961-76-888 468
                                </p>
                            </div>
                            <div className="footerBtns">
                                <div className="btnsCon">
                                    <Footer />
                                </div>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </div>
        </>
    );
};

export default ContactUs;
